import React, { Component } from 'react';
import ContentModel from './models/ContentModel';
import NewsletterSubscriptionFormPage from './views/pages/NewsletterSubscriptionForm.Page';

type AppProps = {
  content: ContentModel;
  translatedErrorMessages: any
}



export default class App extends Component<AppProps> {
  constructor(props: AppProps) {
    super(props);
  }

  public render() {
    return (<NewsletterSubscriptionFormPage content={this.props.content} translatedErrorMessages={this.props.translatedErrorMessages} />);
  }
}